import { ViewChild, ElementRef, Component, OnInit } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { HomeService } from '../../services/home.service';
import { PerfectScrollbarModule, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';


declare var jQuery:any;
@Component({
  selector: 'app-meditation',
  templateUrl: './meditation.component.html',
  styleUrls: ['./meditation.component.scss']
})
export class MeditationComponent implements OnInit {
  @ViewChild('closeModal') closeModal: ElementRef;
  meditationDetailsObj:any={image:'',lengths:[]};
  meditationLength:Number;
  meditationAudioDetailsObj:any={results:[]}
  therapyActiveNumber:Number;
  therapySelectNumber:Number;
  backgroundSoundIndex:Number=2;
  // public config: PerfectScrollbarConfigInterface = {};
  onGoingPage:Boolean=false;
  audioPlayed:Boolean=false;
  counter:Number=5;
  timerInterval:any;
  audioType:string='play';
  audioDuration:any='0:00';
  audioCurrentTime:any='0:00';
  audioWidth:string='0%';
  audiosrc:string='';
  bgSoundSrc:string='';
  progressInterval:any;
  getAudioDetailsInterval:any;
  showFeedbackContent:boolean=true;
  showFeedback:boolean=false;
  disableSendFeedback:boolean=false;
  feedbackBtnText:string='';
  feedback_id:Number=null;
  smiley1:string='assets/images/1.png';
  smiley2:string='assets/images/2.png';
  smiley3:string='assets/images/3.png';
  smiley4:string='assets/images/4.png';
  @ViewChild('audioOption') audioPlayerRef: ElementRef;
  @ViewChild('bgSoundOption') bgSoundPlayerRef: ElementRef;
  constructor(private homeService: HomeService, private router:Router) { }

  ngOnInit() {
    let url = this.router.url;
    if(url.indexOf('ongoing') > -1) {
      this.onGoingPage = true;
      let meditationObj= JSON.parse(sessionStorage.getItem('therapyObj'));
      if(meditationObj) {
        this.audiosrc = meditationObj['audio'];
        this.bgSoundSrc = sessionStorage.getItem('backgroundSound');
        this.updateMeditaion(meditationObj['id']);
        this.showCounter();
        this.audioLoad();
      } else {
        this.router.navigate(['/single-meditation']);
      }
    } 
    this.getMeditationDetails();
  }

  showCounter() {
    this.timerInterval = setInterval(() => {
      this.counter = +this.counter-1;
      if(this.counter == 0) {
        clearInterval(this.timerInterval);
        this.audioPlayed = true;
      }
    }, 1000);
  }

  audioLoad() {
    this.getAudioDetailsInterval = setInterval(() => {
      // if(parseInt(this.audioDuration) >0 && parseInt(this.audioCurrentTime) >0 && this.audioPlayed) {
      //   if(this.bgSoundSrc) {
      //     this.bgSoundPlayerRef.nativeElement.play();
      //   }
      //   this.audioPlay();
      //   // console.log('audioload');
      //   clearInterval(this.getAudioDetailsInterval);
      // }
      this.getAudioDetails(); 
    }, 1000);
  }

  updateMeditaion(id) {
    let obj = {"completed":true}
    this.homeService.updateMeditationInfo(id,obj).subscribe(res=>{
    });
  }

  getMeditationDetails() {
    this.homeService.meditationSettings().subscribe(res=>{
      this.meditationDetailsObj = res;
      if(res.lengths.length >0) {
        this.meditationLength = res.lengths[0];
      }
      this.getMeditationAudioDetails(this.meditationLength);
    });
  }

  getMeditationAudioDetails(meditationLength) {
    this.homeService.meditationAudioDetails(meditationLength).subscribe(res=>{
      if(res['results'].length >0) {
        this.therapyActiveNumber = res['results'][0].id;
        this.therapySelectNumber = res['results'][0].id;
        let url = this.router.url;
        if(url.indexOf('ongoing') == -1) {
          sessionStorage.setItem('therapyObj',JSON.stringify(res['results'][0]));
        }
      }
      this.meditationAudioDetailsObj = res;
    });
  }

  backgroundSoundFn(number) {
    this.backgroundSoundIndex = number
    if(number == 0) {
      sessionStorage.setItem('backgroundSound',this.meditationDetailsObj.sounds.nature);
    }else if(number == 1) {
      sessionStorage.setItem('backgroundSound',this.meditationDetailsObj.sounds.beat);
    } else {
      sessionStorage.removeItem('backgroundSound');
    }
  }

  meditationLengthFn(number) {
    this.meditationLength = number;
    this.getMeditationAudioDetails(this.meditationLength);
  }

  therapyNumberFn(obj) {
    this.therapyActiveNumber = obj.id;
    sessionStorage.setItem('therapyObj',JSON.stringify(obj));
  }

  meditationLengthSelect(value) {
    this.meditationLength = value;
    this.getMeditationAudioDetails(this.meditationLength);
  }

  bgSoundSelect(value) {
    this.backgroundSoundIndex = value;
    if(value == 0) {
      sessionStorage.setItem('backgroundSound',this.meditationDetailsObj.sounds.nature);
    }else if(value == 1) {
      sessionStorage.setItem('backgroundSound',this.meditationDetailsObj.sounds.beat);
    } else {
      sessionStorage.removeItem('backgroundSound');
    }
  }

  therapySelect(obj) {
    this.therapySelectNumber = obj;
    for(let index of this.meditationAudioDetailsObj.results){
      if(index.id == this.therapySelectNumber) {
        sessionStorage.setItem('therapyObj',JSON.stringify(index));
      }
    }
  }

  startMeditation() {
    this.router.navigate(['/single-meditation/ongoing'])
  }

  closeMeditaionModal() {
    this.audioType = 'pause';
    this.audioPlayerRef.nativeElement.play();
    if(this.bgSoundSrc) {
      this.bgSoundPlayerRef.nativeElement.play();
    }
    jQuery('#cancel-meditation-modal').modal('toggle');
  }

  navigate(url) {
    sessionStorage.clear();
    if(this.progressInterval) {
      this.audioPlayerRef.nativeElement.pause();
      if(this.bgSoundSrc) {
        this.bgSoundPlayerRef.nativeElement.pause();
      }
      clearInterval(this.progressInterval);
    }
    if(this.getAudioDetailsInterval) {
      clearInterval(this.getAudioDetailsInterval);
    }
    jQuery('.modal-backdrop').remove();
    this.router.navigate([url])
  }

  cancelMeditation() {
    this.audioType = 'play';
    this.audioPlayerRef.nativeElement.pause();
  }

  audioPlay() {    
    if(this.audioPlayed) {
      // if(this.audioCurrentTime == '0:00') {
      //   alert('Please wait audio is taking some time to load...');
      //   return true;
      // }
      if(this.audioType == 'play') {
        this.playTheAudio();
        this.progressInterval = setInterval(() => {
          this.getAudioDetails(); 
        }, 1000);
      }else {
        this.pauseTheAudio();
      }
    }
  }

  playTheAudio() {
    this.audioType = 'pause';
    this.audioPlayerRef.nativeElement.play();
    this.audioPlayerRef.nativeElement.volume = 1.0;
    if(this.bgSoundSrc) {
      this.bgSoundPlayerRef.nativeElement.play();
      this.bgSoundPlayerRef.nativeElement.volume = 0.1;
    }
  }

  pauseTheAudio() {
    this.audioType = 'play';
    this.audioPlayerRef.nativeElement.pause();
    if(this.bgSoundSrc) {
      this.bgSoundPlayerRef.nativeElement.pause();
    }
  }

  getAudioDetails() {
    var audioElement = <any>document.getElementById("exerciseAudio");
    if(audioElement == null) {
      return true;
    }
    let duration = audioElement.duration | 0;
    let currentTime = audioElement.currentTime | 0;
    let width = 100 / duration * currentTime;
    if(width == 100) {
      //Show the feedback modal when audio is completed.
      jQuery('#complete-meditation-window').modal('show');
    }
    
    // if(currentTime == 0 && this.audioPlayed) {
    //   this.playTheAudio();
    //   if(this.bgSoundSrc) {
    //     this.bgSoundPlayerRef.nativeElement.play();
    //   }
    // }

    if(width <=100){
      let totalMinutes = this.formatTime(duration)
      this.audioDuration = totalMinutes;
      let time = this.formatCurrentTime(currentTime)
      this.audioCurrentTime = time;
      this.audioWidth = width+'%';
    }
  }

  getBgSoundDetails() {
    var audioElement = <any>document.getElementById("bgSoundAudio");
    let duration = audioElement.duration | 0;
    let totalMinutes = this.formatTime(duration)
    return totalMinutes;
  }

  formatTime(seconds) {
    let minutes = Math.floor(seconds / 60)
    if (minutes >= 10) {
      minutes = minutes
    }else if(minutes == 0) {
      minutes = 0
    }
    let second:any;
    second = Math.floor(seconds % 60)
    if (second >= 10) {
      second = second
    }else {
      second = '0'+second
    }
    let minute = minutes + ':' + second
     return minute;
  }

  formatCurrentTime(seconds) {
    let minutes:any;
    minutes = Math.floor(seconds / 60)
    let second:any;
    second = Math.floor(seconds % 60)
    if (second < 10) {
      second = '0'+second
    }
    let minute = minutes + ':' + second
     return minute;
  }

  onChangeFeedbackInput(value) {
    this.disableSendFeedback = true;
  }

  rating(number) {
    this.imagesUrl();
    switch (number) {
      case 1:
          this.smiley1='assets/images/active_1.png';
          break;
      case 2:
          this.smiley2='assets/images/active_2.png';
          break;
      case 3:
          this.smiley3='assets/images/active_3.png';
          break;
      case 4:
          this.smiley4='assets/images/active_4.png';
          break;
    }
    this.feedback_id = number;
    this.showFeedback = true;
  }

  imagesUrl() {
    this.smiley1='assets/images/1.png';
    this.smiley2='assets/images/2.png';
    this.smiley3='assets/images/3.png';
    this.smiley4='assets/images/4.png';
  }

  feedbackNotNow(value?) {
    this.showFeedbackContent =false;
    if(value != 'no') {
      let type = 'meditations';
      let meditationObj= JSON.parse(sessionStorage.getItem('therapyObj'));
      let id = meditationObj.id;
      let obj = JSON.stringify({feedback_id:this.feedback_id,comment:this.feedbackBtnText});
      this.homeService.saveFeedback(type,id,obj).subscribe(res => {
      })
    }
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/meditation/meditation.component.ts